/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconBulletFill from '@telus-uds/palette-public-mobile/build/rn/icons/BulletFill'
const theme = {
  appearances: {
    compact: {
      description: 'When true it will reduce the line height of the list item.',
      type: 'variant',
      values: [ true ]
    },
    size: {
      description: 'Indicates list item text size.',
      type: 'variant',
      values: [ 'large', 'small' ]
    }
  },
  rules: [
    {
      if: { size: 'large' },
      tokens: {
        iconMarginTop: 4,
        itemFontSize: 20,
        itemIconSize: 20,
        itemLineHeight: 1.4
      }
    },
    {
      if: { size: 'small' },
      tokens: {
        iconMarginTop: 2,
        itemFontSize: 16,
        itemLineHeight: 1.55555555
      }
    },
    {
      if: { compact: true },
      tokens: { iconMarginTop: 2, itemLineHeight: 1.55555555 }
    },
    {
      if: { compact: true, size: 'small' },
      tokens: { itemLineHeight: 1.5 }
    },
    {
      if: { compact: true, size: 'large' },
      tokens: { itemLineHeight: 1.2 }
    }
  ],
  tokens: {
    bulletIcon: PaletteIconBulletFill,
    dividerColor: '#9c9faa',
    dividerSize: 1,
    iconMarginTop: 4,
    interItemMargin: 8,
    interItemMarginWithDivider: 16,
    itemBulletColor: '#394056',
    itemBulletContainerAlign: 'center',
    itemBulletContainerHeight: 20,
    itemBulletContainerWidth: 24,
    itemFontName: 'SofiaPro',
    itemFontSize: 18,
    itemFontWeight: '400',
    itemIconColor: '#394056',
    itemIconSize: 20,
    itemLineHeight: 1.55555555,
    itemTextColor: '#394056',
    listGutter: 8
  }
}
export default theme
